import { render, staticRenderFns } from "./DistrictCreateEditModal.vue?vue&type=template&id=9c454986&"
import script from "./DistrictCreateEditModal.vue?vue&type=script&lang=js&"
export * from "./DistrictCreateEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports